/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradeV1TradeState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADE_V1_TRADE_STATE_ENTITY_NAME = 'ixc.trade.v1.Trade';
export const ixcTradeV1TradeStateEntity = new schema.Entity<IxcTradeV1TradeState>(IXC_TRADE_V1_TRADE_STATE_ENTITY_NAME, {}, { idAttribute: 'tradeId' });

